<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>观察点配置详情</span>
          <div class="toolbar-items">

          </div>
        </div>
      </template>
    </el-page-header>

    <el-divider class="detail-divider"></el-divider>
    <el-tabs>
      <el-tab-pane label="基本信息">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="编码" class="detail-form-item" prop="name">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="类型" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.type">
                        <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="中心服务器" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" value-key="id" v-model="entity.centreServer">
                        <el-option v-for="item in centreServers" :key="item.id" :label="item.name" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="巡航服务器" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" value-key="id" v-model="entity.cruiseServer">
                        <el-option v-for="item in cruiseServers" :key="item.id" :label="item.name" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="算法服务器" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" value-key="id" v-model="entity.algorithmServer">
                        <el-option v-for="item in algorithmServers" :key="item.id" :label="item.name" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="文件服务器" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" value-key="id" v-model="entity.fileServer">
                        <el-option v-for="item in fileServers" :key="item.id" :label="item.name" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="客户端" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" value-key="id" v-model="entity.singleClient">
                        <el-option v-for="item in singleClients" :key="item.itemKey" :label="item.name" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="中心客户端" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" value-key="id" v-model="entity.centreClient">
                        <el-option v-for="item in centreClients" :key="item.itemKey" :label="item.name" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" rows="5" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="观察目标">
        <div class="detail-containe-product">
          <el-scrollbar>
            <div class="table-toolbar">
              <el-button size="mini" type="primary" @click="addListRow(entity.nodeDetails)">新增巡航目标</el-button>
            </div>
            <el-table :data="entity.nodeDetails" border style="width:100%" @row-click="rowClick">
              <el-table-column prop="no" label="序号" width="100"> </el-table-column>
              <el-table-column prop="name" label="目标编号" width="200">
                <template #default="scope">
                  <span v-if="scope.row.edit">
                    <el-input size="mini" v-model="scope.row.code">
                    </el-input>
                  </span>
                  <span v-else>{{scope.row.code}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="label" label="目标名称" width="360">
                <template #default="scope">
                  <span v-if="scope.row.edit">
                    <el-input size="mini" v-model="scope.row.name">
                    </el-input>
                  </span>
                  <span v-else>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="defaultValue" label="备注">
                <template #default="scope">
                  <span v-if="scope.row.edit">
                    <el-input size="mini" v-model="scope.row.remark">
                    </el-input>
                  </span>
                  <span v-else>{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180">
                <template #default="scope">
                  <el-button size="mini" type="danger" @click="deleteListRow(scope,entity.nodeDetails,entity.nodeDeleteDetails)">删除巡航目标</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="巡航管理">
        <div class="detail-containe-product">
          <el-container style="height:100%;">
            <el-header style="height:48px;">
              <div>
                <el-button size="small" @click="save">新增设备组</el-button>
                <el-button size="small" type="primary" plain @click="goBack">新增相机</el-button>
                <el-button size="small" type="primary" plain @click="reset">新增巡航路线</el-button>
                <span class="label-left">巡航控制：</span>
                <el-button size="small" type="success" @click="cruiseStart">启动巡航</el-button>
                <el-button size="small" type="danger" @click="cruiseStop">停止巡航</el-button>
                <el-button size="small" @click="cruisePause">暂停巡航</el-button>
                <el-button size="small" @click="cruiseContinue">继续巡航</el-button>
              </div>
            </el-header>
            <el-container>
              <el-aside width="300px">
                <el-card style="height:calc(100% - 10px);">
                  <el-tree :data="nodeCameraGroups" :props="defaultProps" show-checkbox default-expand-all>
                  </el-tree>
                </el-card>
              </el-aside>
              <el-main style="padding: 0 10px;">
                <el-table border style="width:100%" :data="cruiseList">
                  <el-table-column prop="no" label="序号" width="60"> </el-table-column>
                  <el-table-column prop="camera.name" label="摄像机名称" width="200">
                  </el-table-column>
                  <el-table-column prop="code" label="巡航路线编号" width="200">
                  </el-table-column>
                  <el-table-column prop="name" label="巡航路线名称">
                  </el-table-column>
                  <el-table-column prop="typeName" label="巡航路线类型" width="120">
                  </el-table-column>
                  <el-table-column prop="enable" label="启用" width="100">
                    <template #default="scope">
                      <div class="column-tag">
                        <span>{{ scope.row.enable?"启用":"禁用" }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="stateName" label="巡航路线状态" width="200">
                  </el-table-column>
                  <el-table-column label="操作" width="80">

                  </el-table-column>
                </el-table>
              </el-main>
            </el-container>
          </el-container>
        </div>
      </el-tab-pane>

    </el-tabs>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>

</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { ElLoading, ElMessage, ElNotification } from "element-plus";
import {
  createCruiseContext,
  createNodeContext,
} from "@/script/apps/recon/config/ReconConfig";
import {
  Cruise,
  Node,
  NodeCameraGroup,
} from "@/script/apps/recon/entity/ReconEntity";
import {
  Camera,
  Client,
  Server,
} from "@/script/apps/device/entity/DeviceEntity";
import {
  createCameraContext,
  createClientContext,
  createServerContext,
} from "@/script/apps/device/config/DeviceConfig";
import { QueryParam } from "@/script/core/service/DataService";
import { NodeService } from "@/script/apps/recon/service/NodeService";
import { DictUtil } from "@/script/core/Dict";

@Options({})
export default class NodeDetail extends BaseDetail {
  centreServers?: Server[] = [];
  fileServers?: Server[] = [];
  cruiseServers?: Server[] = [];
  algorithmServers?: Server[] = [];
  remoteCameras?: Camera[] = [];
  linkageCameras?: Camera[] = [];
  singleClients?: Client[] = [];
  centreClients?: Client[] = [];
  cruiseList?: Cruise[] = [];

  nodeCameraGroups: NodeCameraGroup[] = [];
  defaultProps = {
    children: "cameras",
    label: "name",
  };

  public initData(): ServiceContext {
    return createNodeContext();
  }

  public newEntity() {
    const entity: Node = {};
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    createServerContext().service.loadFullList((data: Server[]) => {
      this.centreServers = data;
      this.fileServers = data;
      this.cruiseServers = data;
      this.algorithmServers = data;
    });

    createCameraContext().service.loadFullList((data: Camera[]) => {
      this.remoteCameras = data;
      this.linkageCameras = data;
    });

    createClientContext().service.loadFullList((data: Client[]) => {
      this.singleClients = data;
      this.centreClients = data;
    });
  }

  public afterLoad(data: any) {
    const node = this.entity as Node;
    node.nodeDeleteDetails = [];
    this.generateListRowNo(node.nodeDetails!);

    (this.serviceContext.service as NodeService)
      .loadCameraTree(node.id!)
      .then((result: any) => {
        this.nodeCameraGroups = result.data as NodeCameraGroup[];
      });

    this.loadCruises();
  }

  private loadCruises() {
    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .loadCruisesByNode(node.id!)
      .then((result: any) => {
        this.cruiseList = result.data as Cruise[];
        this.cruiseList.forEach((item) => {
          item.typeName = DictUtil.getItemValue("rec-cruise-type", item.type);
          item.stateName = DictUtil.getItemValue(
            "rec-cruise-state",
            item.state!
          );
        });
        this.generateListRowNo(this.cruiseList);
      });
  }

  public cruiseStart() {
    const loading = ElLoading.service({
      lock: true,
      text: "巡航启动中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .cruiseStart(node.id!)
      .then((response) => {
        loading.close();
        ElMessage.success("启动成功！");
        this.loadCruises();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error(error.message);
      });
  }

  public cruiseStop() {
    const loading = ElLoading.service({
      lock: true,
      text: "巡航停止中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .cruiseStop(node.id!)
      .then((response) => {
        loading.close();
        ElMessage.success("停止成功！");
        this.loadCruises();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error(error.message);
      });
  }

  public cruisePause() {
    const loading = ElLoading.service({
      lock: true,
      text: "巡航暂停中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .cruisePause(node.id!)
      .then((response) => {
        loading.close();
        ElMessage.success("巡航暂停成功！");
        this.loadCruises();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error(error.message);
      });
  }

  public cruiseContinue() {
    const loading = ElLoading.service({
      lock: true,
      text: "巡航继续运行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .cruiseContinue(node.id!)
      .then((response) => {
        loading.close();
        ElMessage.success("继续运行成功！");
        this.loadCruises();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error(error.message);
      });
  }
}
</script>

<style lang="scss">
</style>
